import { escapeHtml } from "../../../../utils/escapeHtml";
import { CHIP_ICON_SVG } from "./chipIcons";

// One chip anatomy (VIS-02) for labor, non-labor, Space and Stock: the acronym
// segment, coloured with its load marker when the resource has one, then, only
// when there is a value, a light body segment holding it inside the same pill.
// ResourceChip.js renders the same markup in React; laborChipTemplate.js
// reuses the acronym and body helpers.

// `cls` / `testId`: the caller's own hooks on the acronym (the labor chip's).
// With a load, the testId goes on the acronym text: the segment itself carries
// the badge test id.
export const resourceChipAcronymHtml = (model, { cls = "", testId = "" } = {}) => {
  const text = escapeHtml(model.acronym);
  const classes = ["offolio-resource-chip__acronym", cls].filter(Boolean);
  const testIdAttr = (id) => (id ? ` data-testid="${id}"` : "");
  if (!model.badge) return `<span class="${classes.join(" ")}"${testIdAttr(testId)}>${text}</span>`;
  const { icon } = model.badge;
  const role = model.badgeInteractive ? 'role="button" tabindex="0" aria-haspopup="dialog"' : 'role="img"';
  return `<span class="${[...classes, "offolio-resource-chip__badge"].join(" ")}" data-testid="${model.badgeTestId}" ${role} aria-label="${escapeHtml(model.badgeAriaLabel)}"><i class="offolio-resource-chip__icon offolio-resource-chip__icon--${icon}" aria-hidden="true">${CHIP_ICON_SVG[icon] || ""}</i><span class="offolio-resource-chip__acronym-text"${testIdAttr(testId)}>${text}</span></span>`;
};

export const resourceChipBodyHtml = (innerHtml) =>
  innerHtml ? `<span class="offolio-resource-chip__body">${innerHtml}</span>` : "";

export const resourceChipHtml = (model) => {
  const value = model.valueText
    ? `<span class="offolio-resource-chip__value" data-testid="${model.valueTestId}">${escapeHtml(model.valueText)}</span>`
    : "";
  return `<div class="${model.rootClass}" data-testid="${model.testId}" data-resource-id="${escapeHtml(model.resourceId)}" data-dimension="${escapeHtml(model.dimension)}" data-btip="${escapeHtml(escapeHtml(model.tooltip))}" role="group" aria-label="${escapeHtml(model.ariaLabel)}"${model.compact ? ' style="aspect-ratio: 1 / 1"' : ""}>${model.compact ? `<span class="offolio-resource-chip__acronym">${escapeHtml(model.acronym)}</span>` : resourceChipAcronymHtml(model) + resourceChipBodyHtml(value)}</div>`;
};
